import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';

import { BehaviorSubject, catchError, Observable, of, tap } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  // Retrieve session data
  session: any = sessionStorage.getItem("data");
  data = JSON.parse(this.session);
  navihationMenu: NavigationMenuItem[] = this.data?.navihationMenu || [];
  
  private url: string;
  public sessiondata = new BehaviorSubject<[]>([]);
  public $NavigationMenu = new BehaviorSubject<number>(0);
  currentRoute: any;

  constructor(private http: HttpClient) {}

  // This method takes a route as input and returns a list of booleans indicating if the user has permission on Add, Edit, and Delete
  checkPermissionsForRoute(route: string): boolean[] {
    debugger
    const navigationMenu = this.navihationMenu;
    
    // Find the menu item that matches the provided route
    const menuItem = navigationMenu.find((item: NavigationMenuItem) => {
      return item.externalUrl === route || (item.controllerName + '/' + item.actionName) === route;
    });

    if (menuItem && menuItem.permissionActions) {
      // Check permissions for Add, Edit, and Delete
      const permissions = menuItem.permissionActions;
      const canAdd = permissions.some((action: PermissionAction) => action.name === 'Add/Create' && action.isAvailable);
      const canEdit = permissions.some((action: PermissionAction) => action.name === 'Update' && action.isAvailable);
      const canDelete = permissions.some((action: PermissionAction) => action.name === 'Delete' && action.isAvailable);

      return [canAdd, canEdit, canDelete]; // Returns a list of booleans: [canAdd, canEdit, canDelete]
    }

    return [false, false, false]; // Default if no permissions found
  }
  getPermissionsForScreen(controllerName: string): Observable<PermissionAction[]> {
    return this.http.get<PermissionAction[]>(`${environment.apiRoot}/api/Permission/GetPermissionsForScreen?ControllerName=${controllerName}`);
  }
  GetPermissionsForScreenUrl(externalUrl: string): Observable<PermissionAction[]> {
    console.log("Fetching permissions from API for URL:", externalUrl);
    
    return this.http.get<PermissionAction[]>(`${environment.apiRoot}/api/Permission/GetPermissionsForScreenUrl?ExternalUrl=${externalUrl}`)
      .pipe(
        tap(response => console.log("API Response:", response)), // Log response
        catchError(error => {
          console.error("Error fetching permissions:", error);
          return of([]); // Prevent null errors
        })
      );
  }
  
  
  refreshRouterOutlet() {
    console.log('Router outlet refreshed');
    this.onRouterOutletActivate(null);  // Manually call the method to refresh
  }

  onRouterOutletActivate(event: any) {
    console.log('Router outlet activated:', event);
    if (event) {
      this.hasGrid(event);
    } else {
      console.log('No component to activate.');
    }
  }
  
  hasGrid(component: any): boolean {
    if (!component) {
      console.warn('Component is undefined or null.');
      return false;
    }
  
    console.log('Checking if the component has a grid:', component);
  
    const myVar = 'grid' as keyof typeof component;
  
   
    setTimeout(() => {
      
      console.log('Checking grid after setTimeout:', component[myVar]);
  
      if (!this.currentRoute) {
        console.warn('No route found, skipping permission check.');
        return;
      }
       // Ensure the component has a grid property
      if (!component[myVar]) {
        console.warn('Grid property does not exist in component.');
        return ;
      }
  
  
      // Fetch permissions asynchronously
      this.GetPermissionsForScreenUrl(this.currentRoute).subscribe(
        (permissions: any) => {
          console.log('Permissions received:', permissions);
  
          if (component?.grid?.instance) {
            const grid = component.grid.instance;
            console.log('grid', grid);
            // Apply permissions dynamically
            const allowAdding = this.hasPermission(permissions, 'Add/Create');
            const allowUpdating = this.hasPermission(permissions, 'Update/Edite'); // Fix here
            const allowDeleting = this.hasPermission(permissions, 'Delete');
            
            console.log('Permissions received:', permissions);
            console.log('Grid Permissions:', {
              allowAdding,
              allowUpdating,
              allowDeleting
            });
            
            grid.option('editing', {
              allowAdding,
              allowUpdating,
              allowDeleting
            });
            
            console.log('Grid permissions updated successfully.');
          } else {
            console.warn('Grid instance not found in component.');
          }
        },
        (error) => {
          console.error('Error fetching permissions:', error);
        }
      );
    }, 0);
  
    return true;
  }
  
  hasPermission(permissions: PermissionAction[], permissionName: string): boolean {
    return permissions.some(p => p.name === permissionName && p.isAvailable);
  }
  
}
export interface PermissionAction {
  id: number;
  name: string;
  isAvailable: boolean;

}



interface NavigationMenuItem {
  id: number;
  nameAr: string;
  nameEn: string;
  parentId: number | null;
  controllerName: string;
  actionName: string;
  externalUrl: string;
  permissionActions: PermissionAction[];
  styleClass: string | null;
  visable: boolean;
  xStore: boolean;
}